import { bigNumberToNumberUNSAFE } from '@lyra/core/utils/bigNumberToNumberUNSAFE'
import { Abi, Address } from 'viem'

import d2VaultAbi from '../abis/d2VaultAbi'
import { getNetworkClient } from '../utils/rpc'
import { DepositNetwork } from './chains'
import { USDC_DECIMALS } from './contracts'
import { CollateralId } from './tokens'

export enum PartnerVaultId {
  DgnBtcV2 = 'DgnBtcV2',
}

export type PartnerVaultConfig = {
  id: PartnerVaultId
  name: string
  abi: Abi
  collateralId: CollateralId
  strategyTitle: string
  strategyDescription: string
  url: string
  imageUrl: string
  apyRange: string
  contractAddress: Address
  getTotalSupply: () => Promise<bigint>
  getTvl: () => Promise<number>
  getBalance: (address: Address) => Promise<bigint>
}

export const D2_VAULT: PartnerVaultConfig = {
  id: PartnerVaultId.DgnBtcV2,
  name: 'dgnBTCv2',
  abi: d2VaultAbi,
  collateralId: CollateralId.USDC, // Note: may also need DepositTokenId
  strategyTitle: 'Bullish BTC',
  strategyDescription:
    'Provides up to 2x BTC returns with a downside similar to holding BTC. This strategy works directly through lending partners to facilitate BTC exposure, leveraging looping of 2-3x on average depending on market conditions and benefiting from funding arbitrage shorting Perp when at premium. The remaining capital flow and repackaged yield are utilized in Derive, combining options for long volatility exposure with delta hedging and momentum signals.',
  url: 'https://d2.finance/strategies/dgnBTCv2?chainId=8453&tab=2',
  imageUrl: '/images/partners/dgnbtcv2.png',
  apyRange: 'Est 5-30%',
  contractAddress: '0x6c05A7d2c24B48fC3C615D294fEc2eB068548897',
  getTotalSupply: async () => {
    const baseClient = await getNetworkClient(DepositNetwork.Base)
    return await baseClient.readContract({
      address: D2_VAULT.contractAddress,
      abi: d2VaultAbi,
      functionName: 'totalDeposits',
      args: [],
    })
  },
  getTvl: async () => {
    const totalSupply = await D2_VAULT.getTotalSupply()
    return bigNumberToNumberUNSAFE(totalSupply, USDC_DECIMALS)
  },
  getBalance: async (wallet: Address) => {
    const baseClient = await getNetworkClient(DepositNetwork.Base)
    return await baseClient.readContract({
      address: D2_VAULT.contractAddress,
      abi: d2VaultAbi,
      functionName: 'balanceOf',
      args: [wallet],
    })
  },
}

export const PARTNER_VAULTS: Record<PartnerVaultId, PartnerVaultConfig> = {
  [PartnerVaultId.DgnBtcV2]: D2_VAULT,
}
